import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Send the httpOnly auth cookie with every request.
axios.defaults.withCredentials = true;

export async function parseDocument(file) {
  const form = new FormData();
  form.append("file", file);
  const res = await axios.post(`${API}/parse-document`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function saveProposal(payload) {
  const res = await axios.post(`${API}/proposals`, payload);
  return res.data;
}

export async function uploadDocument(file) {
  const form = new FormData();
  form.append("file", file);
  const res = await axios.post(`${API}/uploads/document`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function saveDraft(draftId, data) {
  await axios.put(`${API}/drafts/${draftId}`, data);
}

export async function getDraft(draftId) {
  const res = await axios.get(`${API}/drafts/${draftId}`);
  return res.data;
}

export async function ensureShareToken(id) {
  const res = await axios.post(`${API}/proposals/${id}/share`);
  return res.data;
}

export function sharedPdfUrl(token) {
  return `${API}/proposals/shared/${token}`;
}

export function sharedLandingUrl(token) {
  return `${window.location.origin}/p/${token}`;
}

export async function fetchSharedSummary(token) {
  const res = await axios.get(`${API}/proposals/shared/${token}/summary`);
  return res.data;
}

export async function getRates() {
  const res = await axios.get(`${API}/rates`);
  return res.data;
}

export async function updateRates(data) {
  const res = await axios.put(`${API}/rates`, data);
  return res.data;
}

export async function getFirstNations() {
  const res = await axios.get(`${API}/first-nations`);
  return res.data;
}

export async function emailProposal(blob, event, lead, total) {
  const form = new FormData();
  const fileName = `${(event.eventTitle || "SmartBallot-Proposal").replace(/\s+/g, "-")}.pdf`;
  form.append("pdf", blob, fileName);
  form.append("eventTitle", event.eventTitle || "Proposal");
  form.append("total", String(total));
  form.append("leadName", lead.name || "");
  form.append("leadEmail", lead.email || "");
  form.append("leadOrg", lead.organization || lead.firstNation || "");
  form.append("leadFirstNation", lead.firstNation || "");
  form.append("to", lead.email || ""); // deliver the proposal to the recipient's own email
  const res = await axios.post(`${API}/proposals/email`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function getProposals(email) {
  const res = await axios.get(`${API}/proposals`, {
    params: email ? { email } : undefined,
  });
  return res.data;
}

export async function resendProposal(id, toEmail) {
  const res = await axios.post(
    `${API}/proposals/${id}/resend`,
    toEmail ? { to: toEmail } : {}
  );
  return res.data;
}

export async function sendCustomEmail(id, { subject, message, to, attachProposal }) {
  const res = await axios.post(
    `${API}/proposals/${id}/send-email`,
    { subject, message, to: to || undefined, attachProposal: !!attachProposal }
  );
  return res.data;
}

export async function fetchProposalDocument(id) {
  const res = await axios.get(`${API}/proposals/${id}/document`, {
    responseType: "blob",
  });
  return res.data;
}

export async function fetchProposalPdf(id) {
  const res = await axios.get(`${API}/proposals/${id}/pdf`, {
    responseType: "blob",
  });
  return res.data;
}

export async function saveProposalPdf(id, pdfBase64) {
  const res = await axios.post(`${API}/proposals/${id}/pdf`, { pdfBase64 });
  return res.data;
}

export async function sendProposalEmail(blob, proposal, toEmail) {
  const form = new FormData();
  const fileName = `${(proposal.eventTitle || "SmartBallot-Proposal").replace(/\s+/g, "-")}.pdf`;
  form.append("pdf", blob, fileName);
  form.append("eventTitle", proposal.eventTitle || "Proposal");
  form.append("total", String(proposal.total || 0));
  form.append("leadName", proposal.lead?.name || "");
  form.append("leadEmail", proposal.lead?.email || "");
  form.append("leadOrg", proposal.lead?.organization || proposal.lead?.firstNation || "");
  form.append("leadFirstNation", proposal.lead?.firstNation || "");
  if (toEmail) form.append("to", toEmail);
  const res = await axios.post(`${API}/proposals/email`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}
